export { useCrazyMode, KYOKI_THEME_ID } from './useCrazyMode';
export type { CrazyModeState, CrazyModeActions } from './useCrazyMode';
